import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date-hour" }

import { debounce } from "lodash-es";
import { ref, onMounted, watch } from "vue";
import { useI18n } from "vue-i18n";

import { baseDate, baseHour, baseTextarea } from "@/common/components";
import moment from "moment";


export default /*@__PURE__*/_defineComponent({
  __name: 'date-edit',
  props: {
    data: {},
    width: { default: "100%" },
    patch: { type: Boolean, default: false }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const emit = __emit;

const props = __props;

const payload = ref<{
  date: string | null;
  hour: string | null;
  motive: string | null;
}>({
  date: moment().format("YYYY-MM-DD"),
  hour: moment().format("HH:mm:ss"),
  motive: "",
});

function update(key: keyof typeof payload.value) {
  if (props.patch) {
    emit("update-data", { [key]: payload.value[key] });
    return;
  }

  emit("update-data", {
    ...payload.value,
    [key]: payload.value[key],
  });
}

function formatData() {
  if (!props.data?.date) {
    return;
  }

  payload.value = {
    date: props.data.date,
    hour: props.data.hour,
    motive: props.data?.motive || "",
  };
}

const debounceForm = debounce(update, 300);

watch(
  () => props.data,
  () => {
    formatData();
  }
);

onMounted(() => {
  formatData();

  emit("update-data", payload.value);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "form-content",
    style: _normalizeStyle({ width: __props.width })
  }, [
    _createElementVNode("form", null, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(baseDate), {
          modelValue: payload.value.date,
          "onUpdate:modelValue": [
            _cache[0] || (_cache[0] = ($event: any) => ((payload.value.date) = $event)),
            _cache[1] || (_cache[1] = ($event: any) => (update('date')))
          ],
          value: payload.value.date,
          required: true,
          "value-mask": "YYYY-MM-DD",
          placeholder: "--/--/----"
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.date")) + " *", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"]),
        _createVNode(_unref(baseHour), {
          modelValue: payload.value.hour,
          "onUpdate:modelValue": [
            _cache[2] || (_cache[2] = ($event: any) => ((payload.value.hour) = $event)),
            _cache[3] || (_cache[3] = ($event: any) => (update('hour')))
          ],
          value: payload.value.hour,
          required: true,
          "value-mask": "HH:mm:ss",
          placeholder: "--:--:--"
        }, {
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)("common.labels.hour")) + " *", 1)
          ]),
          _: 1
        }, 8, ["modelValue", "value"])
      ]),
      _createVNode(_unref(baseTextarea), {
        modelValue: payload.value.motive,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((payload.value.motive) = $event)),
        value: payload.value.motive,
        placeholder: _unref(t)('common.placeholders.describe'),
        onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(debounceForm)('motive')))
      }, {
        label: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)("common.labels.motive")) + " * ", 1)
        ]),
        _: 1
      }, 8, ["modelValue", "value", "placeholder"])
    ])
  ], 4))
}
}

})